export type { HighlightConfig, HighlightTarget } from './types';
export { add } from './add';
export { default as highlightManager } from './highlightManager';
export { remove } from './remove';
export { start } from './start';
